__turbopack_context__.v({
  "pagination": "slider-pagination-simple-module-scss-module__UzuqJW__pagination",
  "pagination__el": "slider-pagination-simple-module-scss-module__UzuqJW__pagination__el",
  "pagination__el__active": "slider-pagination-simple-module-scss-module__UzuqJW__pagination__el__active",
});
